import HorizonUnit from "./HorizonUnit";
import { Formik } from "formik";
import { If } from "../../../../common/components/If";
import { DateLabel } from "../../constant";

export interface HorizonUnitBase {
	old_value: string;
	new_value: string;
	target_attribute_name: "start_date" | "end_date";
	isDiscarded?: boolean;
}

export interface HorizonUnitHOCProps<T extends HorizonUnitBase> {
	onUpdate: (data: Partial<T>) => void;
	name: string;
	initialValues: T;
	readonly?: boolean;
}

function HorizonUnitHOC<T extends HorizonUnitBase>({
	onUpdate,
	initialValues,
	name,
	readonly = false,
}: HorizonUnitHOCProps<T>) {
	return (
		<If condition={initialValues}>
			<Formik
				enableReinitialize={true}
				initialValues={{
					old_value: initialValues.old_value,
					new_value: initialValues.new_value,
					target_attribute_name: initialValues.target_attribute_name,
					is_checked: !initialValues?.isDiscarded,
				}}
				onSubmit={({
					old_value,
					is_checked,
					new_value,
				}: {
					old_value: string;
					new_value: string;
					is_checked: boolean;
					target_attribute_name: "start_date" | "end_date";

				}) => {
					onUpdate({
						...initialValues,
						old_value,
						new_value,
						isDiscarded: !is_checked,
					});
				}}
			>
				{({
					handleChange,
					handleSubmit,
					values,
					errors,
					setFieldValue,
					submitForm,
				}) => (
					<form onSubmit={handleSubmit}>
						<HorizonUnit
							readonly={readonly}
							name={name}
							attributeName={DateLabel[values.target_attribute_name]}
							oldValue={values.old_value}
							newValue={values.new_value}
							isChecked={values.is_checked}
							oldValueErrorMessage={errors.old_value}
							newValueErrorMessage={errors.new_value}
							onChangeOldValue={(event) => {
								handleChange(event);
								submitForm();
							}}
							onChangeNewValue={(event) => {
								handleChange(event);
								submitForm();
							}}
							onChangeIsChecked={() => {
								setFieldValue("is_checked", !values.is_checked);
								submitForm();
							}}
						/>
					</form>
				)}
			</Formik>
		</If>
	);
}

export default HorizonUnitHOC;
